import { ActionButton } from '@if/mui'
import { Box } from '@mui/material'
import { Printer } from 'lucide-react'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

const FundingSummaryButtonGroup = () => {
  const { t } = useTranslation()

  // A funding confirmation is a document — always print it in light mode, without
  // flipping the on-screen theme. MUI applies the color scheme as a `dark`/`light`
  // class on <html> (theme uses colorSchemeSelector: 'class'), so we swap it only
  // for the print render — which the print dialog covers — and restore it right
  // after. Covers both this button and a plain Ctrl+P while the page is open.
  useEffect(() => {
    const root = document.documentElement
    let restoreDark = false
    const beforePrint = () => {
      if (root.classList.contains('dark')) {
        root.classList.replace('dark', 'light')
        restoreDark = true
      }
    }
    const afterPrint = () => {
      if (restoreDark) {
        root.classList.replace('light', 'dark')
        restoreDark = false
      }
    }
    window.addEventListener('beforeprint', beforePrint)
    window.addEventListener('afterprint', afterPrint)
    return () => {
      window.removeEventListener('beforeprint', beforePrint)
      window.removeEventListener('afterprint', afterPrint)
    }
  }, [])

  return (
    <Box sx={{ '@media print': { display: 'none' } }}>
      <ActionButton fullWidth startIcon={Printer} onClick={() => window.print()}>
        {t('fundingSummary.print')}
      </ActionButton>
    </Box>
  )
}

export default FundingSummaryButtonGroup
